<template>
    <flex-layout>
        <PressReleaseModal />
        <page-header heading="Press Release" action="Add" toggle="offcanvas" target="#offcanvasCreate"
            :guard="this.$route.meta.guard" @click="setCreateForm" />

        <PressReleaseTable :tableHeading="tableHeading" />
    </flex-layout>
</template>

<script>
import FlexLayout from "@/components/Layout/FlexLayout.vue";
import PressReleaseTable from "@/components/PressRelease/table.vue";
import PageHeader from "@/components/Utility/PageHeader.vue";
import PressReleaseModal from "@/components/PressRelease/modal.vue";
export default {
    name: "PressRelease",
    components: {
        PageHeader,
        FlexLayout,
        PressReleaseTable,
        PressReleaseModal
    },
    data() {
        return {
            tableHeading: [
                {
                    heading: "Title",
                },
                {
                    heading: "File",
                },
                {
                    heading: "Status",
                },
            ],
        };
    },
    methods: {
        setCreateForm() {
            this.$root.$emit('CREATE');
        },
    }
};
</script>
